<template>
  <div>
    <!-- Liveness Check Dialog -->
    <v-dialog v-model="dialogOpen" max-width="500" persistent>
      <v-card v-if="verificationStep === 0">
        <v-card-title></v-card-title>
        <v-card-text>
          <div>
            <v-icon color="orange">mdi-information</v-icon>
          </div>
          <div class="text-lg font-semibold text-black mt-4">
            Complete Tier 2 KYC
          </div>
          <div class="text-gray-600 mt-2">
            {{ tier2Message }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="startVerification">Verify Now</v-btn>
          <v-btn text @click="cancelVerification">Cancel</v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="verificationStep === 1">
        <v-card-title></v-card-title>
        <v-card-text>
          <div class="text-lg font-semibold text-black mt-4">
            Level 2 KYC Verification
          </div>
          <div class="text-gray-600 mt-2">
            Please read this information carefully before starting the
            verification process. <b>You will need to take a selfie</b>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="openCamera">Verify Identity Now</v-btn>
          <v-btn text @click="goBack">Back</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Camera Capture Component -->
    <CameraCapture
      :open="showCamera"
      @close="closeCamera"
      @photo-uploaded="handlePhotoUploaded"
    />
  </div>
</template>

<script>
import CameraCapture from './CameraCapture.vue'
import { updateProfile } from '../utils/helpers'

export default {
  name: 'LivenessCheckModal',
  components: {
    CameraCapture
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    tier2Message: {
      type: String,
      default: 'You need to complete Tier 2 KYC verification to access this feature.'
    }
  },
  data() {
    return {
      verificationStep: 0,
      showCamera: false
    }
  },
  computed: {
    dialogOpen: {
      get() {
        return this.open
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  },
  watch: {
    open(newVal) {
      if (newVal) {
        this.resetVerification()
      }
    }
  },
  methods: {
    startVerification() {
      this.verificationStep = 1
    },

    goBack() {
      this.verificationStep = 0
    },

    openCamera() {
      this.showCamera = true
    },

    closeCamera() {
      this.showCamera = false
    },

    handlePhotoUploaded(data) {
      console.log('Photo uploaded successfully:', data)

      // Update user profile with new KYC data
      updateProfile({ profile: data.data })

      // Emit success event to parent
      this.$emit('verification-success', data)

      // Close the modal
      this.closeModal()
    },

    cancelVerification() {
      this.$emit('verification-cancelled')
      this.closeModal()
    },

    closeModal() {
      this.$emit('close')
    },

    resetVerification() {
      this.verificationStep = 0
      this.showCamera = false
    }
  }
}
</script>

<style scoped>
/* Custom styles for the verification dialog */
.v-dialog .v-card {
  border-radius: 12px;
}

.v-card-text {
  padding: 24px;
}

.v-card-actions {
  padding: 16px 24px 24px;
  gap: 8px;
}
</style>
